<template>
  <base-dropdown v-model="isActive" :is-mobile-fullscreen="true" v-bind="$attrs" v-on="events">
    <template v-slot:button="{ toggle, identifier }">
      <slot v-bind="{ toggle, identifier, isActive }">
        <base-button :id="identifier" :class="[{ 'active': isActive }]" title="Press Me" variant="outline-primary-alt" @click="toggle" slot="reference" />
      </slot>
    </template>

    <div class="p-4">
      <base-form-group class="mb-0" v-if="options.length > 0">
        <base-checkbox-group v-model="activeItems" name="active-items" :stacked="true">
          <base-checkbox class="mb-2" :key="option.value" v-for="option in options" :checked="option.value" :disabled="option.disabled">{{option.text}}</base-checkbox>
        </base-checkbox-group>
      </base-form-group>
    </div>

    <template slot="footer" slot-scope="{ ok, cancel }">
      <div class="flex justify-end">
        <base-button :title="$t('label.cancel')" variant="link-danger" @click="cancel()"/>
        <base-button :title="$t('label.apply')" variant="secondary" is-pill class="ml-3" @click="ok()"/>
      </div>
    </template>
  </base-dropdown>
</template>

<script>
import { shortcut } from '@/mixins/helpers'

export default {
  name: 'BaseActiveOptions',

  props: {
    value: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    storageKey: {
      type: String,
      required: true
    },
    shortcut: {
      type: String
    }
  },

  created () {
    this.loadState()
  },

  data () {
    return {
      isActive: false,
      activeItems: this.value,

      events: {
        ok: () => this.onApply(),
        cancel: () => this.onCancel()
      }
    }
  },

  mixins: [ shortcut ],

  computed: {
    shortcuts () {
      return this.shortcut ? [
        { combinations: this.shortcut, action: 'keypress', handler: this.onToggle }
      ] : []
    },

    options () {
      return this.items.map(option => Object.assign(option, { disabled: this.activeItems.length === 1 && this.activeItems.includes(option.value) }))
    }
  },

  methods: {
    /**
     * Load the state from the local storage (if any).
     */
    loadState () {
      const value = JSON.parse(localStorage.getItem(this.storageKey))

      if (value) {
        this.activeItems = value
        this.$emit('input', value)
      }
    },

    /**
     * Save the state to the local storage.
     */
    saveState () {
      localStorage.setItem(this.storageKey, JSON.stringify(this.activeItems))
    },

    onToggle () {
      this.isActive = !this.isActive
    },

    /**
     * Update value and save
     */
    onApply () {
      this.saveState()

      this.$emit('input', this.activeItems)
    },

    /**
     * Reset value
     */
    onCancel () {
      this.activeItems = this.value
    }
  }
}
</script>
